import Alert from '../../common/components/Alert';
import DashboardWidget from './DashboardWidget';
import classList from '../../common/utils/classList';
export default class AlertWidget extends DashboardWidget {
  className() {
    return classList('AlertWidget', this.attrs.className);
  }
  content(vnode) {
    return m(Alert, vnode.attrs.alert, vnode.children);
  }
}
flarum.reg.add('core', 'admin/components/AlertWidget', AlertWidget);